import React from 'react';

const FallBackScreen = () => {
  return (
    <div className='loader_bg'>
      <div>
        <div className='lds-ripple'>
          <div></div>
          <div></div>
        </div>
      </div>
    </div>
  );
};

export default FallBackScreen;
